<template>
    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">LOGS KICK RADIUS</h3>
          </div>
  
          <div class="card-body">
  
            <!-- FILTER -->
            <div class="row mb-3">
              <div class="col-md-2">
                <v-select
                  v-model="filter.status"
                  label="Status"
                  dense
                  clearable
                  :items="statusItems"
                  item-text="text"
                  item-value="value"
                  @change="onFilterChange"
                />
              </div>
  
              <div class="col-md-3">
                <v-menu
                  v-model="menuTanggal"
                  :close-on-content-click="false"
                  offset-y
                  max-width="290"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="tanggalLabel"
                      label="Range Tanggal"
                      dense
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="clearTanggal"
                    />
                  </template>
  
                  <v-date-picker
                    v-model="filter.tanggal"
                    range
                    locale="id-ID"
                    @change="onTanggalChange"
                  />
                </v-menu>
              </div>

              <div class="col-md-4">
                <v-text-field
                  v-model="filter.search"
                  label="Cari Username / NAS IP / Pesan"
                  dense
                  clearable
                  append-icon="mdi-magnify"
                  @input="onFilterChange"
                />
              </div>
              <div class="col-md-3 d-flex align-center pb-6">
                <v-btn small color="warning" @click="kickAllFailed" :loading="loadingKickAll" title="Kick Semua yang Failed">
                    <v-icon left small>mdi-refresh</v-icon>
                    Kick All Failed
                </v-btn>
              </div>
            </div>
  
            <!-- TABLE -->
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :items-per-page="pagination.itemsPerPage"
              :page.sync="pagination.page"
              :server-items-length="totalItems"
              @update:page="fetchData"
              @update:items-per-page="changeItemsPerPage"
            >
              <template #item.no="{ index }">
                {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
              </template>
  
              <template #item.status="{ item }">
                <v-chip small dark :color="statusColor(item.status)">
                  {{ item.status.toUpperCase() }}
                </v-chip>
              </template>
  
              <template #item.created_at="{ item }">
                {{ formatTanggal(item.created_at) }}
              </template>

              <template #item.output="{ item }">
                <div class="d-flex align-center justify-start" style="gap: 8px; width: 100%;">
                    <v-btn small icon @click="showOutput(item)" title="Lihat Output">
                        <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.status === 'failed'"
                      small
                      icon
                      color="warning"
                      @click="reKick(item)"
                      :loading="item.loading"
                      title="Kick Ulang"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                </div>
              </template>
            </v-data-table>
  
          </div>
        </div>
      </div>

      <!-- DIALOG OUTPUT -->
      <v-dialog v-model="dialogOutput" max-width="600">
        <v-card>
            <v-card-title>Raw Output / Error</v-card-title>
            <v-card-text>
                <pre class="bg-dark text-light p-3 rounded" style="white-space: pre-wrap; word-break: break-all;">{{ selectedOutput }}</pre>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialogOutput = false">Tutup</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        loading: false,
        loadingKickAll: false,
        items: [],
        totalItems: 0,
        dialogOutput: false,
        selectedOutput: '',
        menuTanggal: false,
  
        pagination: {
          page: 1,
          itemsPerPage: 50
        },
  
        filter: {
          status: null,
          search: null,
          tanggal: []
        },
  
        statusItems: [
          { text: 'Success', value: 'success' },
          { text: 'Failed', value: 'failed' }
        ],
  
        headers: [
          { text: 'No', value: 'no', width: 50 },
          { text: 'Waktu', value: 'created_at', width: 150 },
          { text: 'Username', value: 'username' },
          { text: 'NAS IP', value: 'nasipaddress' },
          { text: 'Status', value: 'status', width: 100 },
          { text: 'Pesan', value: 'message' },
          { text: 'Aksi', value: 'output', width: 100, sortable: false },
        ]
      }
    },

    computed: {
      tanggalLabel() {
        if (this.filter.tanggal.length === 1) {
          return this.formatDateShort(this.filter.tanggal[0])
        }
        if (this.filter.tanggal.length === 2) {
          const [start, end] = this.filter.tanggal
          return `${this.formatDateShort(start)} - ${this.formatDateShort(end)}`
        }
        return ''
      }
    },
  
    mounted() {
      this.fetchData()
    },
  
    methods: {
      formatDateShort(date) {
        return new Date(date).toLocaleDateString('id-ID', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        })
      },

      formatTanggal(date) {
        if (!date) return '-'
        return new Date(date).toLocaleString('id-ID', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      },
  
      statusColor(status) {
        return status === 'success' ? 'green' : 'red'
      },
  
      onFilterChange() {
        this.pagination.page = 1
        this.fetchData()
      },

      onTanggalChange(val) {
        if (val.length === 2) {
          this.menuTanggal = false
          this.onFilterChange()
        }
      },

      clearTanggal() {
        this.filter.tanggal = []
        this.onFilterChange()
      },
  
      async fetchData() {
        this.loading = true
        try {
          const res = await axios.get('/api/logs/kick', {
            params: {
              page: this.pagination.page,
              per_page: this.pagination.itemsPerPage,
              status: this.filter.status,
              search: this.filter.search,
              date_from: this.filter.tanggal[0] || null,
              date_to: this.filter.tanggal[1] || null
            }
          })
  
          this.items = res.data.data.data
          this.totalItems = res.data.data.total
        } finally {
          this.loading = false
        }
      },
  
      changeItemsPerPage(val) {
        this.pagination.itemsPerPage = val
        this.pagination.page = 1
        this.fetchData()
      },

      showOutput(item) {
          this.selectedOutput = item.output || 'No output recorded.'
          this.dialogOutput = true
      },

      async kickAllFailed() {
        const failedItems = this.items.filter(i => i.status === 'failed');
        if (failedItems.length === 0) {
            Toast.fire({ icon: 'info', title: 'Tidak ada data failed di halaman ini' });
            return;
        }

        if (!confirm(`Yakin ingin melakukan kick ulang untuk ${failedItems.length} user pada halaman ini?`)) return;

        this.loadingKickAll = true;
        let successCount = 0;

        for (const item of failedItems) {
            this.$set(item, 'loading', true);
            let id = item.username;
            if (id.includes('@')) {
                id = id.split('@')[0];
            }
            try {
                const res = await axios.post(`/api/logs/kick/${id}`);
                if (res.data.success) {
                    successCount++;
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.$set(item, 'loading', false);
            }
        }
        
        Toast.fire({ icon: 'success', title: `Selesai memproses ${failedItems.length} user. Berhasil kick ulang: ${successCount}` });
        this.fetchData();
        this.loadingKickAll = false;
      },

      async reKick(item) {
        if (!confirm(`Yakin ingin melakukan kick ulang untuk ${item.username}?`)) return;

        this.$set(item, 'loading', true);
        
        let id = item.username;
        if (id.includes('@')) {
            id = id.split('@')[0];
        }

        try {
          const res = await axios.post(`/api/logs/kick/${id}`);
          if (res.data.success) {
             Toast.fire({ icon: 'success', title: res.data.message || 'Berhasil melakukan kick ulang' });
          } else {
             Toast.fire({ icon: 'warning', title: res.data.message || 'Kick ulang gagal' });
          }
          this.fetchData();
        } catch (error) {
          Toast.fire({ icon: 'error', title: error.response?.data?.message || 'Terjadi kesalahan saat kick ulang' });
        } finally {
          this.$set(item, 'loading', false);
        }
      }
    }
  }
  </script>
